// extracted by mini-css-extract-plugin
module.exports = {"XS":"360px","SM":"640px","MD":"1024px","LG":"1280px","XL":"1440px","xxl":"1920px","Root":"Modal_Root__Hfa2Q","Title":"Modal_Title__2YMWb","Close":"Modal_Close__2J445"};